import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {WorkOrderType} from '../models/workOrderType.model';

@Injectable({
    providedIn: 'root'
})
export class WorkOrderTypeService {

    private API_URL= environment.API_URL;
    private MODEL_URL = 'work-order-types';

    constructor(private http: HttpClient) { }

    getWorkOrderTypes(): Observable<WorkOrderType[]> {
        return this.http.get<WorkOrderType[]>(this.API_URL + this.MODEL_URL);
    }
}
